import {
  GET_REJECTIONS_DOWNLOAD_FAILURE,
  GET_REJECTIONS_DOWNLOAD_REQUEST,
  GET_REJECTIONS_DOWNLOAD_SUCCESS,
  GET_REJECTIONS_REPORT_FAILURE,
  GET_REJECTIONS_REPORT_REQUEST,
  GET_REJECTIONS_REPORT_SUCCESS,
} from "./rejectionsReportTypes";

const initialStateForTransactionReport = {
  loading: false,
  trnReport: [],
  error: "",
};

const getRejectionsReportReducer = (
  state = initialStateForTransactionReport,
  action
) => {
  switch (action.type) {
    case GET_REJECTIONS_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REJECTIONS_REPORT_SUCCESS:
      return {
        loading: false,
        trnReport: action.payload,
        error: "",
      };
    case GET_REJECTIONS_REPORT_FAILURE:
      return {
        loading: false,
        trnReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDownloadGrnReport = {
  loading: false,
  consumptionReport: [],
  error: "",
};

const downloadRejectionsReportReducer = (
  state = initialStateForDownloadGrnReport,
  action
) => {
  switch (action.type) {
    case GET_REJECTIONS_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REJECTIONS_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        consumptionReport: action.payload,
        error: "",
      };
    case GET_REJECTIONS_DOWNLOAD_FAILURE:
      return {
        loading: false,
        consumptionReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getRejectionsReportReducer, downloadRejectionsReportReducer };
